import { useState } from 'react';
import { useLocalStorageSimple } from '../../hooks/useLocalStorage';

import { Basket as BasketModule } from '../../Modules/Basket';
import { Util } from '../../common/util/util';
import { useAppDispatch } from '../../hooks/redux';
import { useActions } from '../../hooks/useActions';
import { useBasket as useReduxBasket } from '../../hooks/useBasket';
import { useUser } from '../../hooks/useUser';

export const useBasket = () => {
  const dispatch = useAppDispatch();
  const [load, setLoad] = useState(false);
  const {
    setAddCardsId,
    setBasketCatalogItems,
    setOrderQuantity,
    setOrderSum,
  } = useActions();
  const { session_token, loggedIn } = useUser();
  //Выбрать все
  const [isAllChecked, setIsAllChecked] = useState(false);
  //Чекнутые id
  const [checkedIds, setCheckedIds] = useState([]);
  //Чекнутый id
  const [checkedId, setCheckedId] = useState([]);
  //Корзина
  const {
    items: basketItems,
    order_sum,
    order_quantity,
    cards_id: addToBasketIds,
  } = useReduxBasket();
  const [sessionToken, setSessionToken] = useLocalStorageSimple('st', '');

  let order_sum_text = `${Util.convertKopecksToRub(order_sum)} ₽`;
  //redux берем из props, чтобы обновлялось
  let catalog_items = Util.clone(basketItems);
  //Сортируем по продавцу (группировка)
  let catalog_items_sort = catalog_items.sort(
    (a: any, b: any) => a.vendor.id - b.vendor.id
  );
  let vendor_id_cur = '';

  //Группировка
  let groups = [];
  let group = {
    vendor: null,
    group_items: [],
  };

  catalog_items_sort.forEach((item: any) => {
    if (vendor_id_cur != item.vendor.id) {
      //Другой продавец

      //Скидываем предыдущий набор
      if (group.vendor != null) {
        groups.push(group);

        //Обнуляем
        group = {
          vendor: null,
          group_items: [],
        };
      }

      group.vendor = item.vendor;
      //Набираем в группу товары
      // @ts-ignore
      group.group_items.push(item);

      vendor_id_cur = item.vendor.id;
    } else {
      //Набираем в группу товары
      // @ts-ignore
      group.group_items.push(item);
    }
  });
  //Скидываем предыдущий набор
  if (group.vendor != null) {
    groups.push(group);

    //Обнуляем
    group = {
      vendor: null,
      group_items: [],
    };
  }

  const deleteItem = async (item_id: any) => {
    //Добавляем в Redux
    //Копируем текущий массив
    let catalog_items = Util.clone(basketItems);
    let ind = addToBasketIds.indexOf(item_id);
    // @ts-ignore
    await BasketModule.deleteItemFromBasket(catalog_items, item_id);
    let basket_info = BasketModule.getInfo(catalog_items);
    let copy_checkedIds = [...addToBasketIds];
    copy_checkedIds.splice(ind, 1);
    setAddCardsId(copy_checkedIds);
    /*Basket.saveToLocalStorageId(copy_checkedIds);*/
    //Сохраняем в LocalStorage
    BasketModule.saveToLocalStorage(catalog_items);
    //Сохраняем в Redux
    setBasketCatalogItems(catalog_items);
    setOrderSum(basket_info.order_sum);
    setOrderQuantity(basket_info.order_quantity);
    //Вызов синхронизации корзины с сервером, если залогинен
    if (loggedIn) {
      //Синхронизация при удалении товара в корзине
      await BasketModule.basketSynchronization(dispatch);
    }
  };

  //Удалить выбранные
  const deleteItems = async () => {
    //Добавляем в Redux
    //Копируем текущий массив
    if (loggedIn && checkedIds.length !== 0) {
      let catalog_items = Util.clone(basketItems);
      //Удалить из корзины
      for (const checkedID of checkedIds) {
        //Последовательно удаляем, хотя можно и параллеьно через await Promise.all и array.map, если не много элементов в корзине
        await BasketModule.deleteItemFromBasket(catalog_items, checkedID);
      }
      let basket_info = BasketModule.getInfo(catalog_items);
      if (isAllChecked) {
        setAddCardsId([]);
        /*Basket.saveToLocalStorageId([]);*/
      } else {
        let ind = addToBasketIds.indexOf(checkedId);

        let copy_checkedIds = [...addToBasketIds];
        copy_checkedIds.splice(ind, 1);
        setAddCardsId(copy_checkedIds);
        /*Basket.saveToLocalStorageId(copy_checkedIds);*/
      }
      //Сохраняем в LocalStorage
      BasketModule.saveToLocalStorage(catalog_items);
      //Сохраняем в Redux
      setBasketCatalogItems(catalog_items);
      setOrderSum(basket_info.order_sum);
      setOrderQuantity(basket_info.order_quantity);
      //Вызов синхронизации корзины с сервером, если залогинен
      //Синхронизация при удалении товара(ов) из корзины
      if (loggedIn) {
        await BasketModule.basketSynchronization(dispatch);
        setCheckedIds([]);
      }
    }
  };

  //Выбрать все
  const handleAllOnChange = (checked: any) => {
    setIsAllChecked(checked);
    if (checked) {
      //Добавляем в массив
      let ids: any = [];
      let items = basketItems;
      items.forEach((it: any) => ids.push(it.id));
      setCheckedIds(ids);
    } else {
      //Удаляем из массива
      setCheckedIds([]);
    }
  };

  //Чекнутая?
  const isChecked = (item_id: any) => {
    // @ts-ignore
    let ind = checkedIds.indexOf(item_id);
    return ind != -1 ? true : false;
  };

  //Чек
  const handleOnChange = (checked: any, item_id: any) => {
    // @ts-ignore
    let ind = checkedIds.indexOf(item_id);

    if (checked) {
      //Добавляем в массив
      if (ind == -1) {
        let copy_checkedIds = [...checkedIds];
        // @ts-ignore
        copy_checkedIds.push(item_id);
        setCheckedIds(copy_checkedIds);
        setCheckedId(item_id);
      }
    } else {
      //Удаляем из массива
      if (ind != -1) {
        let copy_checkedIds = [...checkedIds];
        copy_checkedIds.splice(ind, 1);
        setCheckedIds(copy_checkedIds);
        setCheckedId(item_id);
      }
    }
  };

  return {
    basket: {
      isChecked,
      groups,
      isAllChecked,
    },
    actions: {
      handleOnChange,
      handleAllOnChange,
      deleteItems,
      deleteItem,
    },
  };
};
